/* eslint-disable */
import React from "react";
import {NavLink, useLocation} from "react-router-dom";
// chakra imports
import {Box, Flex, HStack, Text, Tooltip, useColorModeValue} from "@chakra-ui/react";
import {useAuth} from "../../../contexts/AuthContext";
import { useTranslation } from 'react-i18next'

export function SidebarLinks(props) {
    const { user } = useAuth()
    const { t } = useTranslation()
    //   Chakra color mode
    let location = useLocation();
    let activeColor = useColorModeValue("gray.700", "white");
    let inactiveColor = useColorModeValue(
        "secondaryGray.600",
        "secondaryGray.600"
    );
    let activeIcon = useColorModeValue("brand.500", "white");
    let textColor = useColorModeValue("secondaryGray.500", "white");
    let brandColor = useColorModeValue("brand.500", "brand.400");

    const {routes, collapsed = false} = props;
    const getRouteLabel = route => (route.nameKey ? t(route.nameKey) : route.name)

    const activeRoute = (routeName) => {
        return location.pathname.includes(routeName);
    };

    const filterRoutesByPermission = (route) => {
        const userPermissionSet = new Set(user?.permissions?.map(permission => permission.slug))

        if (user?.is_employee && route.employeePermission && route.employeePermission !== 'no'){
            return userPermissionSet.has(route.employeePermission)
        }

        if (route.permission) {
            return userPermissionSet.has(route.permission)
        }

        return true
    }

    // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
    const createLinks = (routes) => {
        return routes.map((route, index) => {
            if (!filterRoutesByPermission(route)) return

            if (route.category) {
                return (
                    <>
                        {!collapsed && (
                            <Text
                                fontSize={"md"}
                                color={activeColor}
                                fontWeight='bold'
                                mx='auto'
                                ps={{
                                    sm: "10px",
                                    xl: "16px",
                                }}
                                pt='18px'
                                pb='12px'
                                key={index}>
                                {getRouteLabel(route)}
                            </Text>
                        )}
                        {createLinks(route.items)}
                    </>
                );
            } else if (
                !route.dontShow &&
                (route.layout === "/admin" ||
                route.layout === "/auth" ||
                route.layout === "/rtl")
            ) {
                if (collapsed) {
                    return (
                        <NavLink key={index} to={route.layout + route.path}>
                            <Tooltip label={getRouteLabel(route)} placement='right' hasArrow openDelay={100}>
                                <Flex
                                    position='relative'
                                    alignItems='center'
                                    justifyContent='center'
                                    py='10px'
                                    my='2px'>
                                    <Box
                                        color={
                                            activeRoute(route.path.toLowerCase())
                                                ? activeIcon
                                                : textColor
                                        }>
                                        {route.icon || (
                                            <Text fontWeight='bold' fontSize='md'>
                                                {(getRouteLabel(route) || "?").charAt(0)}
                                            </Text>
                                        )}
                                    </Box>
                                    <Box
                                        position='absolute'
                                        right='0'
                                        h='36px'
                                        w='4px'
                                        bg={
                                            activeRoute(route.path.toLowerCase())
                                                ? brandColor
                                                : "transparent"
                                        }
                                        borderRadius='5px'
                                    />
                                </Flex>
                            </Tooltip>
                        </NavLink>
                    );
                }

                return (
                    <NavLink key={index} to={route.layout + route.path}>
                        {route.icon ? (
                            <Box>
                                <HStack
                                    spacing={
                                        activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                                    }
                                    py='5px'
                                    ps='10px'>
                                    <Flex w='100%' alignItems='center' justifyContent='center'>
                                        <Box
                                            color={
                                                activeRoute(route.path.toLowerCase())
                                                    ? activeIcon
                                                    : textColor
                                            }
                                            me='18px'>
                                            {route.icon}
                                        </Box>
                                        <Text
                                            me='auto'
                                            color={
                                                activeRoute(route.path.toLowerCase())
                                                    ? activeColor
                                                    : textColor
                                            }
                                            fontWeight={
                                                activeRoute(route.path.toLowerCase())
                                                    ? "bold"
                                                    : "normal"
                                            }>
                                            {getRouteLabel(route)}
                                        </Text>
                                    </Flex>
                                    <Box
                                        h='36px'
                                        w='4px'
                                        bg={
                                            activeRoute(route.path.toLowerCase())
                                                ? brandColor
                                                : "transparent"
                                        }
                                        borderRadius='5px'
                                    />
                                </HStack>
                            </Box>
                        ) : (
                            <Box>
                                <HStack
                                    spacing={
                                        activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                                    }
                                    py='5px'
                                    ps='10px'>
                                    <Text
                                        me='auto'
                                        color={
                                            activeRoute(route.path.toLowerCase())
                                                ? activeColor
                                                : inactiveColor
                                        }
                                        fontWeight={
                                            activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
                                        }>
                                        {getRouteLabel(route)}
                                    </Text>
                                    <Box h='36px' w='4px' bg='brand.400' borderRadius='5px'/>
                                </HStack>
                            </Box>
                        )}
                    </NavLink>
                );
            }
        });
    };
    //  BRAND
    return createLinks(routes);
}

export default SidebarLinks;
